import { useEffect, useState } from "react";
import ComingSoon from "../common/ComingSoon";
import AddRole from "../components/rol-management/AddRole";
import RoleHeader from "../components/rol-management/RoleHeader";
import RoleManagementListing from "../components/rol-management/RoleManagementListing";
import UserHeader from "../components/user-components/UserHeader";
import UserSideMenu from "../components/user-components/UserSideMenu";
import { NoModuleRights } from "../utils/utils";

const User = () => {

    const [subCategory, setSubCategory] = useState(!NoModuleRights('Users') ? "user" : "roleManagement");
    const [searchValue, setSearchValue] = useState("");
    const [roleEditId, setRoleEditID] = useState("");
    const [roleName, setRoleName] = useState("");
    const userRights = NoModuleRights('Users');

    useEffect(() => {
        setSubCategory(!userRights ? "user" : "roleManagement");
    }, [userRights]);

    return (
        <>
            <div className="dashbord-content">
                <div className="dashbord-content-inner">
                    <UserSideMenu
                        subCategory={subCategory}
                        setSubCategory={setSubCategory}
                        setRoleEditID={setRoleEditID}
                        setRoleName={setRoleName}
                    />
                    <div className="content-right-box">
                        <div className="intro-table-search container-fluid">
                            {subCategory === "user" && (
                                <UserHeader
                                    searchValue={searchValue}
                                    setSearchValue={setSearchValue}
                                />
                            )}
                            {subCategory === "roleManagement" && (
                                <>
                                    <RoleHeader setSubCategory={setSubCategory} subCategory={subCategory} setRoleEditID={setRoleEditID} setRoleName={setRoleName} />
                                </>
                            )}
                            {subCategory === "add_role" && (
                                <AddRole setSubCategory={setSubCategory} roleEditId={roleEditId} setRoleEditID={setRoleEditID} setRoleName={setRoleName} roleName={roleName} />
                            )}
                        </div>
                    </div>
                    {/* <CreateDocument /> */}
                </div>
            </div>
        </>
    )
};

export default User;